import { useTranslation } from 'react-i18next';

import type { ImportJob } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';

/** Marks a products import that updated existing handles; a skip job shows nothing. */
export function ImportModeBadge({ job }: { job: Pick<ImportJob, 'kind' | 'onExisting'> }) {
  const { t } = useTranslation('importsExports');
  if (job.kind !== 'products_csv' || job.onExisting !== 'update') return null;
  return (
    <Badge variant="outline" title={t('mode.updateTitle')}>
      {t('mode.update')}
    </Badge>
  );
}
